export default {
  bind: function (el, binding, vnode) {
    el.onclick = function(e) {
      el.classList.toggle("hidden")
    }
  }
}